<div class="powerbi-report">
  <iframe
    title="HandlingAppReports v2"
    width="1140"
    height="541.25"
    src="https://app.powerbi.com/reportEmbed?reportId=a571fc1c-023b-4842-b491-9b925bdf4746&autoAuth=true&ctid=1a47d566-67d6-448f-93dc-19565d759c26"
    frameborder="0"
    allowFullScreen="true"
  ></iframe>
</div>
